import { Check, Link as LinkIcon, MessageCircle, Twitter } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

function searchDeepLink(s) {
  const qs = new URLSearchParams();
  if (s.genre && s.genre !== "All") qs.set("genre", s.genre);
  if (s.bpm && s.bpm !== "all") qs.set("bpm", s.bpm);
  if (s.key && s.key !== "all") qs.set("key", s.key);
  const query = qs.toString();
  return "/beats" + (query ? `?${query}` : "");
}

/**
 * Three one-tap share chips (WhatsApp, X/Twitter, copy link) for a saved pocket.
 * `search` can be a saved-row {genre,bpm,key,label} or the current active filters.
 */
export function PocketShareButtons({ search, variant = "row" }) {
  const [copied, setCopied] = useState(false);
  const absoluteUrl =
    (typeof window !== "undefined" ? window.location.origin : "") + searchDeepLink(search);
  const label = search.label || "my pocket";
  const message = `Check these beats in ${label} on PRODRUSHI: ${absoluteUrl}`;
  const waHref = `https://wa.me/?text=${encodeURIComponent(message)}`;
  const twHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(absoluteUrl);
      setCopied(true);
      toast.success("Link copied — paste it anywhere");
      setTimeout(() => setCopied(false), 1600);
    } catch {
      toast.error("Couldn't copy — long-press the link instead");
    }
  };

  const base =
    variant === "inline"
      ? "inline-flex h-7 w-7 items-center justify-center rounded-full border border-white/10 text-zinc-400 transition-colors hover:border-emerald-300/40 hover:text-emerald-200"
      : "inline-flex h-8 w-8 items-center justify-center rounded-full border border-white/10 text-zinc-400 transition-colors hover:border-emerald-300/40 hover:text-emerald-200";

  return (
    <div className="inline-flex items-center gap-1.5" data-testid="pocket-share-buttons">
      <a
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        className={base}
        aria-label="Share on WhatsApp"
        data-testid="pocket-share-whatsapp"
        title="Share on WhatsApp"
      >
        <MessageCircle size={13} />
      </a>
      <a
        href={twHref}
        target="_blank"
        rel="noopener noreferrer"
        className={base}
        aria-label="Share on X / Twitter"
        data-testid="pocket-share-twitter"
        title="Share on X"
      >
        <Twitter size={13} />
      </a>
      <button
        type="button"
        onClick={copy}
        className={base}
        aria-label="Copy pocket link"
        data-testid="pocket-share-copy"
        title="Copy link"
      >
        {copied ? <Check size={13} className="text-emerald-300" /> : <LinkIcon size={13} />}
      </button>
    </div>
  );
}
